import { jsx } from "react/jsx-runtime";
import { MenuRenderer } from "../MenuRenderer/MenuRenderer.mjs";
import { ButtonIcon } from "../ButtonIcon/ButtonIcon.mjs";
import { Box } from "../Box/Box.mjs";
import "../Text/TextContext.mjs";
import "../Heading/HeadingContext.mjs";
import "../../css/lineHeightContainer.css.mjs";
import "../../css/reset/reset.css.mjs";
import "../../css/atoms/sprinkles.css.mjs";
import "../../hooks/useIcon/icon.css.mjs";
import "../../css/typography.css.mjs";
import { IconMoreVert } from "../icons/IconMoreVert/IconMoreVert.mjs";
import { triggerOffset } from "./OverflowMenu.css.mjs";
const OverflowMenu = ({ label, children, id, ...menuProps }) => /* @__PURE__ */ jsx(
  MenuRenderer,
  {
    trigger: (triggerProps) => /* @__PURE__ */ jsx(Box, { display: "flex", justifyContent: "flexEnd", className: triggerOffset, children: /* @__PURE__ */ jsx(
      ButtonIcon,
      {
        id,
        icon: /* @__PURE__ */ jsx(IconMoreVert, {}),
        variant: "transparent",
        label,
        ...triggerProps
      }
    ) }),
    align: "right",
    offsetSpace: "small",
    ...menuProps,
    children
  }
);
export {
  OverflowMenu
};
